import React, { useContext } from 'react'
import { CustomModal } from '../../CustomModal/CustomModal';
import useWindowSize from '../../../customHooks/useWindowSize'
import PermanenceReportContext from '../../../context/PermanenceReportContext/PermanenceReportContext';
import PermanenceTotalsDetailTable from './PermanenceTotalsDetailTable/PermanenceTotalsDetailTable';
import PermanenceTotalsDetailListSimple from './PermanenceTotalsSimple/PermanenceTotalsDetailListSimple';
import PermanenceTotals from './PermanenceTotals';
import { t } from 'i18next';
import { getTenantInfoByKey } from '../../../helpers/helpers';

const PermanenceTotalsDetailModal = ({ showModal, setShowModal }) => {

    const { windowWidth } = useWindowSize();
    const fullscreen = windowWidth <= 576

    const { permanenceReportState } = useContext(PermanenceReportContext);
    const { totalsReports, totalReport } = permanenceReportState;

    const haveBuildings = getTenantInfoByKey('is_building');
    const haveAccessOpenings = getTenantInfoByKey('is_access_opening');

    const title = () => {
        if (haveAccessOpenings === true && haveBuildings === false) {
            return `${t('TOTAL_HS_PER')} ${getTenantInfoByKey('opening_name')}`;
        }

        if (haveAccessOpenings === true && haveBuildings === true) {
            return `${t('TOTAL_HS_PER')} ${getTenantInfoByKey('opening_name')}`;
        }

        if (haveAccessOpenings === false && haveBuildings === true) {
            return `${t('TOTAL_HS_PER')} ${getTenantInfoByKey('building_name')}`;
        }

        return t('TOTAL_HS')
    }

    return (
        <CustomModal
            showModal={showModal}
            setShowModal={setShowModal}
            fullscreen={fullscreen}
            backgroundColor={fullscreen ? 'var(--white)' : 'var(--gray-50)'}
            size='xl'
            style={{ padding: '0' }}
        >
            <div style={{ overflowX: 'hidden' }}>
                <div className='row p-4'>

                    <div className="col d-block d-sm-none">
                        <i
                            type='button'
                            onClick={setShowModal}
                            className="fa-solid fa-arrow-left fs-3"
                        >
                        </i>
                    </div>
                    <div className="col">
                        <h5 className={`m-0 custom-h4 text-center text-nowrap text-sm-start fw-medium`}>
                            {title()}
                        </h5>
                    </div>
                    <div className="col d-flex justify-content-end">
                        <i
                            type='button'
                            onClick={setShowModal}
                            className="fa-solid fa-xmark fs-3 d-sm-block d-none"
                        >
                        </i>
                    </div>
                </div>

                <div>
                    <div className="d-none d-sm-block p-4">
                        <PermanenceTotalsDetailTable totalsReports={totalsReports} />
                    </div>
                    <div className="d-sm-none d-block">
                        <div className='p-4'>
                            <PermanenceTotals
                                haveDetail={false}
                                totals={totalReport}
                            />
                        </div>
                        <PermanenceTotalsDetailListSimple totalsReports={totalsReports} />
                    </div>
                </div>

            </div>

        </CustomModal>
    )
}

export default PermanenceTotalsDetailModal